import { Image as datoCmsImage } from 'vue-datocms'
import RichTextSection from '~/components/public/rich-text-section.vue'
import ResponsiveVideo from '~/components/public/responsive-video.vue'


export default {
  __name: 'section-with-image',
  props: {
  actions: {
    type: Array,
    required: true,
  },
  displayVideo: {
    type: Boolean,
    default: null,
  },
  image: {
    type: Object,
    required: true,
  },
  text: {
    type: Object,
    required: true,
  },
  textLocation: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  video: {
    type: Object,
    default: null,
  },
},
  setup(__props) {



return { __sfc: true,datoCmsImage, RichTextSection, ResponsiveVideo }
}

}